import React from 'react'
import { Pagination } from 'react-admin'

const CustomPagination = ({ rows, ...props }) => (
  <Pagination rowsPerPageOptions={rows} {...props} />
)

export default CustomPagination
